import React from "react";
import ReactSlick from "react-slick";
import PropTypes from "prop-types";
import defaultImg from "../images/house/defaultImg.svg";

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

const CustomButton = ({ currentSlide, slideCount, ...props }) => <button {...props} />;

const Slider = ({ courses }) => {
    const settings = {
        prevArrow: <CustomButton />,
        nextArrow: <CustomButton />,
        dots: false,
        infinite: false,
        speed: 200,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipe: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="slider-container">
            <ReactSlick {...settings}>
                {courses.map((item) => (
                    <a href={item.href} key={item.id} className="course">
                        <img
                            className="course__logo"
                            alt="course_logo"
                            src={item.src || defaultImg}
                        />
                        <span className="course__name">{item.name}</span>
                    </a>
                ))}
            </ReactSlick>
        </section>
    );
};

Slider.propTypes = {
    courses: PropTypes.array,
};

export default Slider;



// WEBPACK FOOTER //
// ./app/frontend/components/Slider.js